var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.masterTags.length > 0 || _vm.tags.length > 0
    ? _c("div", { staticClass: "searchCard hideOnMobile--block" }, [
        _c("div", { staticClass: "searchCard__box" }, [
          _c(
            "div",
            {
              staticClass:
                "searchCard__head flex flex__justifyItems--start flex__alignItems--center",
            },
            [
              _c(
                "svg",
                {
                  staticClass: "searchIcon--32 searchIcon__right",
                  attrs: { height: "32", width: "32", "aria-hidden": "true" },
                },
                [_c("use", { attrs: { href: "#iconTagDuo" } })]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "searchCard__headline" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.trans("MOST_USED_TAGS")) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "facetedSearch__tooltip flex" }, [
                _c(
                  "svg",
                  {
                    staticClass:
                      "searchIcon--16 facetedSearch_info searchIcon__left",
                    attrs: { height: "16", width: "16", "aria-hidden": "true" },
                  },
                  [_c("use", { attrs: { href: "#iconInfoReg" } })]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "facetedSearch__tooltipText" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.trans("SELECT_MOST_USED_TAGS_INFO")) +
                      "\n                "
                  ),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "facetedSearch__content facetedSearch__content--selected flex",
            },
            _vm._l(_vm.tags, function (tag) {
              return _c(
                "button",
                {
                  key: tag,
                  staticClass:
                    "facetedSearch__tag facetedSearch__tag--selected flex flex__alignItems--center",
                  attrs: {
                    type: "button",
                    "data-faceted-search": "",
                    "data-gtm": `facetedSearch__removeTag${tag}`,
                    "aria-label": `Remove tag ${tag}`,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.removeTag(tag)
                    },
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "left", 37, $event.key, [
                          "Left",
                          "ArrowLeft",
                        ])
                      )
                        return null
                      if ("button" in $event && $event.button !== 0) return null
                      return _vm.changeFocus.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "facetedSearch__tag--ellipsis facetedSearch__tag--ellipsisSelected",
                    },
                    [_vm._v(_vm._s(tag))]
                  ),
                  _vm._v(" "),
                  _c(
                    "svg",
                    {
                      staticClass: "searchIcon--16 facetedSearch__deleteIcon",
                      attrs: {
                        height: "16",
                        width: "16",
                        "aria-hidden": "true",
                      },
                    },
                    [_c("use", { attrs: { href: "#iconCrossBold" } })]
                  ),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "facetedSearch__content flex" },
            _vm._l(_vm.tagsOptions, function (tagsOption) {
              return _c("div", { key: tagsOption.tag }, [
                !_vm.tags.includes(tagsOption.tag)
                  ? _c("div", [
                      _c(
                        "button",
                        {
                          staticClass:
                            "facetedSearch__tag facetedSearch__tag--ellipsis",
                          attrs: {
                            type: "button",
                            "data-gtm": `facetedSearch__tag--${tagsOption.tag}`,
                            "data-faceted-search": "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.addTag(tagsOption.tag)
                            },
                            keydown: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k($event.keyCode, "left", 37, $event.key, [
                                  "Left",
                                  "ArrowLeft",
                                ])
                              )
                                return null
                              if ("button" in $event && $event.button !== 0)
                                return null
                              return _vm.changeFocus.apply(null, arguments)
                            },
                          },
                        },
                        [_c("span", [_vm._v(_vm._s(tagsOption.tag))])]
                      ),
                    ])
                  : _vm._e(),
              ])
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _vm.tags.length > 0
          ? _c(
              "div",
              {
                staticClass:
                  "facetedSearch__reset flex flex__justifyContent--center flex__alignItems--center",
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "facetedSearch__resetText",
                    attrs: {
                      type: "button",
                      "data-gtm": "facetedSearch__resetAllTags",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.resetTags()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.trans("RESET_MOST_USED_TAGS")) +
                        "\n            "
                    ),
                    _c(
                      "svg",
                      {
                        staticClass:
                          "searchIcon--16 searchIcon__left facetedSearch__resetIcon",
                        attrs: {
                          height: "16",
                          width: "16",
                          "aria-hidden": "true",
                        },
                      },
                      [
                        _c("use", {
                          attrs: { href: "#iconArrowClockwiseBold" },
                        }),
                      ]
                    ),
                  ]
                ),
              ]
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }